import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PainelFavoritos from '../components/PainelFavoritos';

function getEmailDoToken() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return '';
    // JWT usa base64url: normaliza antes do atob (senão '-'/'_' quebram a decodificação)
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).email || '';
  } catch { return ''; }
}

function token() { return localStorage.getItem('token'); }

function statusTarefa(t) {
  if (t.realizado) return { label: 'Feito', cor: '#16a34a', bg: '#f0fdf4' };
  if (!t.data_agendada) return { cor: '#9ca3af', bg: '#f9fafb' };
  const dStr = t.data_agendada.slice(0, 10);
  const hojeLocal = new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);
  if (dStr < hojeLocal) return { label: 'Atrasada', cor: '#dc2626', bg: '#fef2f2' };
  return { label: 'Pendente', cor: '#d97706', bg: '#fffbeb' };
}

function fmtDt(iso) {
  if (!iso || !iso.includes('T')) return '';
  const d = new Date(iso);
  const brt = new Date(d.getTime() - 3 * 60 * 60 * 1000);
  const [, timePart] = brt.toISOString().split('T');
  return timePart.slice(0, 5);
}

const MODULOS = [
  { path: '/agenda',        icon: '📅', label: 'Agenda' },
  { path: '/clientes',      icon: '👥', label: 'Clientes' },
  { path: '/crm',           icon: '📋', label: 'CRM' },
  { path: '/sdr',           icon: '📞', label: 'SDR' },
  { path: '/saudadora',     icon: '🤖', label: 'Saudadora', destaque: true, apenasVagner: true },
  { path: '/closer',        icon: '🧭', label: 'Closer', consultores: true },
  { path: '/demandas',      icon: '⚖️', label: 'Demandas Processuais' },
  { path: '/sucesso-cliente', icon: '💚', label: 'Sucesso do Cliente', apenasVagner: true },
  { path: '/financeiro',    icon: '💵', label: 'Financeiro', apenasVagner: true },
  { path: '/gerador',       icon: '📁', label: 'Gerador de Arquivos' },
  { path: '/oportunidades', icon: '🎯', label: 'Oportunidades' },
  { path: '/relatorios',    icon: '📊', label: 'Relatórios' },
  { path: '/inpi',          icon: '🏛️', label: 'INPI' },
  { path: '/parceiros',     icon: '🤝', label: 'Parceiros',     consultores: true },
  { path: '/utilitarios',   icon: '🧰', label: 'Utilitários' },
  { path: '/comunicacao',   icon: '💬', label: 'Comunicação', apenasVagner: true },
  { path: '/assistente',    icon: '✨', label: 'Clau IA', destaque: true, apenasVagner: true },
  { path: '/sugestoes',     icon: '💬', label: 'Respostas IA',  destaque: true, apenasVagner: true },
  { path: '/agente-vendas', icon: '🤖', label: 'Agente de Vendas', destaque: true, apenasVagner: true },
];

function MiniCalendario({ navigate }) {
  const [tarefas, setTarefas] = useState([]);
  const [mes, setMes] = useState(() => { const h = new Date(); return { ano: h.getFullYear(), mes: h.getMonth() }; });
  const [diaExpandido, setDiaExpandido] = useState(null);

  useEffect(() => {
    fetch('/agenda', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(setTarefas).catch(() => {});
  }, []);

  const { ano, mes: m } = mes;
  const nomeMes = new Date(ano, m, 1).toLocaleString('pt-BR', { month: 'long' });
  const primeiroDia = new Date(ano, m, 1).getDay();
  const diasNoMes = new Date(ano, m + 1, 0).getDate();
  const hoje = new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);

  const tarefasPorDia = {};
  tarefas.forEach(t => {
    if (!t.data_agendada) return;
    const dia = t.data_agendada.slice(0, 10);
    if (!tarefasPorDia[dia]) tarefasPorDia[dia] = [];
    tarefasPorDia[dia].push(t);
  });

  const celulas = [];
  for (let i = 0; i < primeiroDia; i++) celulas.push(null);
  for (let d = 1; d <= diasNoMes; d++) celulas.push(d);
  while (celulas.length % 7 !== 0) celulas.push(null);

  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', width: '100%' }}>
      <div style={{ background: '#0a1628', padding: '8px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button onClick={() => setMes(({ ano, mes }) => { const d = new Date(ano, mes - 1, 1); return { ano: d.getFullYear(), mes: d.getMonth() }; })}
            style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: 4, padding: '1px 6px', cursor: 'pointer', fontSize: 12 }}>‹</button>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 12, textTransform: 'capitalize', minWidth: 110, textAlign: 'center' }}>{nomeMes} {ano}</span>
          <button onClick={() => setMes(({ ano, mes }) => { const d = new Date(ano, mes + 1, 1); return { ano: d.getFullYear(), mes: d.getMonth() }; })}
            style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: 4, padding: '1px 6px', cursor: 'pointer', fontSize: 12 }}>›</button>
        </div>
        <button onClick={() => navigate('/agenda')} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 10, fontWeight: 600 }}>
          Ver agenda →
        </button>
      </div>

      <div style={{ padding: 8 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2, marginBottom: 3 }}>
          {['D','S','T','Q','Q','S','S'].map((d, i) => (
            <div key={i} style={{ textAlign: 'center', fontSize: 9, fontWeight: 700, color: '#9ca3af' }}>{d}</div>
          ))}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
          {celulas.map((dia, i) => {
            if (!dia) return <div key={i} />;
            const chave = `${ano}-${String(m + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
            const itens = tarefasPorDia[chave] || [];
            const ehHoje = chave === hoje;
            return (
              <div key={i} onClick={() => itens.length > 0 && setDiaExpandido(diaExpandido === chave ? null : chave)}
                style={{ height: 48, overflow: 'hidden', border: `1px solid ${diaExpandido === chave ? '#0a1628' : ehHoje ? '#0a1628' : '#e5e7eb'}`, borderRadius: 3, padding: '2px 2px', background: ehHoje ? '#f0f4ff' : '#fafafa', cursor: itens.length > 0 ? 'pointer' : 'default' }}>
                <div style={{ fontSize: 9, fontWeight: ehHoje ? 700 : 400, color: ehHoje ? '#0a1628' : '#374151', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{dia}</span>
                  {itens.length > 0 && <span style={{ fontSize: 7, background: '#0a1628', color: '#fff', borderRadius: 8, padding: '0 3px' }}>{itens.length}</span>}
                </div>
                {itens.slice(0, 2).map((t, j) => {
                  const st = statusTarefa(t);
                  return (
                    <div key={j} style={{ fontSize: 8, background: st.bg, color: st.cor, borderRadius: 2, padding: '0 2px', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {t.descricao}
                    </div>
                  );
                })}
                {itens.length > 2 && <div style={{ fontSize: 7, color: '#9ca3af' }}>+{itens.length - 2}</div>}
              </div>
            );
          })}
        </div>

        {diaExpandido && tarefasPorDia[diaExpandido] && (() => {
          const [dAno, dMes, dDia] = diaExpandido.split('-');
          const itensExp = tarefasPorDia[diaExpandido];
          return (
            <div style={{ marginTop: 8, background: '#fff', border: '1px solid #0a1628', borderRadius: 6, padding: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: '#0a1628' }}>{dDia}/{dMes}/{dAno.slice(2)} — {itensExp.length} tarefa{itensExp.length !== 1 ? 's' : ''}</span>
                <button onClick={() => setDiaExpandido(null)} style={{ background: 'none', border: 'none', fontSize: 14, cursor: 'pointer', color: '#6b7280', lineHeight: 1 }}>×</button>
              </div>
              {itensExp.map((t, j) => {
                const st = statusTarefa(t);
                return (
                  <div key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 5, padding: '4px 6px', borderRadius: 4, background: st.bg, border: `1px solid ${st.cor}33`, marginBottom: 4 }}>
                    <span style={{ fontSize: 8, fontWeight: 700, color: st.cor, background: '#fff', border: `1px solid ${st.cor}`, borderRadius: 3, padding: '1px 3px', whiteSpace: 'nowrap', marginTop: 1 }}>{st.label}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 10, fontWeight: 600, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.descricao}</div>
                      {t.cliente_nome && <div style={{ fontSize: 9, color: '#6b7280' }}>👤 {t.cliente_nome}</div>}
                      {fmtDt(t.data_agendada) && <div style={{ fontSize: 9, color: '#6b7280' }}>⏰ {fmtDt(t.data_agendada)}</div>}
                    </div>
                    {(t.cliente_id || t.oportunidade_id) && (
                      <button onClick={() => { if (t.cliente_id) navigate(`/clientes/${t.cliente_id}/editar`); else navigate('/crm'); }}
                        style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 3, padding: '2px 6px', fontSize: 9, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}>
                        {t.cliente_id ? 'Ver' : 'CRM'}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })()}
      </div>
    </div>
  );
}

// Home em blocos (só o Vagner vê assim): módulos agrupados por área de trabalho
const GRUPOS_VAGNER = [
  { titulo: '📈 Comercial', paths: ['/crm', '/sdr', '/saudadora', '/closer', '/oportunidades', '/parceiros'] },
  { titulo: '🗂 Operação',  paths: ['/clientes', '/agenda', '/demandas', '/sucesso-cliente', '/inpi'] },
  { titulo: '📊 Gestão',    paths: ['/financeiro', '/relatorios', '/comunicacao'] },
  { titulo: '🧰 Apoio',     paths: ['/gerador', '/utilitarios', '/assistente', '/sugestoes', '/agente-vendas'] },
];

export default function Home() {
  const navigate = useNavigate();
  const emailUsuario = getEmailDoToken();
  const ehV = emailUsuario === 'vagnerfreittas@gmail.com';
  const ehCloser = (localStorage.getItem('cargoUsuario') || '').toLowerCase().includes('closer');
  const modulos = MODULOS.filter(m => {
    if (m.apenasVagner) return ehV;
    if (m.consultores) return ehV || ehCloser;
    return true;
  });

  const Botao = ({ path, icon, label, destaque }) => (
    <button
      key={path}
      onClick={() => navigate(path)}
      style={{
        display: 'flex', alignItems: 'center', gap: 10,
        background: destaque ? 'linear-gradient(135deg,#3b82f6,#8b5cf6)' : '#fff',
        border: destaque ? 'none' : '1px solid #e5e7eb', borderRadius: 8,
        padding: '9.5px 16px', cursor: 'pointer', textAlign: 'left',
        boxShadow: destaque ? '0 4px 14px rgba(99,102,241,0.35)' : '0 1px 4px rgba(0,0,0,0.06)',
        transition: 'all 0.15s', fontSize: 13, fontWeight: 600,
        color: destaque ? '#fff' : '#0a1628', width: '100%',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(4px)'; e.currentTarget.style.boxShadow = destaque ? '0 6px 20px rgba(99,102,241,0.5)' : '0 4px 14px rgba(10,22,40,0.18)'; if (!destaque) { e.currentTarget.style.background = '#0a1628'; e.currentTarget.style.color = '#fff'; } }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateX(0)'; e.currentTarget.style.boxShadow = destaque ? '0 4px 14px rgba(99,102,241,0.35)' : '0 1px 4px rgba(0,0,0,0.06)'; if (!destaque) { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#0a1628'; } }}
    >
      <span style={{ fontSize: 15 }}>{icon}</span>
      {label}
    </button>
  );

  // Visão do Vagner: logo no topo + 4 blocos por área
  if (ehV) {
    const porPath = Object.fromEntries(MODULOS.map(m => [m.path, m]));
    return (
      <div className="home-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18, padding: '8px 0', minHeight: '80vh', justifyContent: 'center' }}>
        <img src="/logo.png" alt="Preserva Marcas" style={{ maxWidth: 360, width: '70%' }} />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14, width: '100%', maxWidth: 1100 }}>
          {GRUPOS_VAGNER.map(g => (
            <div key={g.titulo} style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 12, padding: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: 11.5, fontWeight: 800, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 8 }}>{g.titulo}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                {g.paths.map(p => porPath[p] && <Botao key={p} {...porPath[p]} />)}
              </div>
            </div>
          ))}
        </div>
        {/* ⭐ Favoritos: recolhido por padrão, abre só no clique (oportunidades + anotações) */}
        <PainelFavoritos />
      </div>
    );
  }

  // Visão da equipe: coluna única, igual sempre foi
  return (
    <div className="home-wrapper" style={{ display: 'flex', alignItems: 'center', minHeight: '80vh', marginLeft: -24, gap: 20 }}>

      {/* Coluna de botões (altura compacta — metade da original) */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: 220, flexShrink: 0 }}>
        {modulos.map(m => <Botao key={m.path} {...m} />)}
      </div>

      {/* Logo */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src="/logo.png" alt="Preserva Marcas" style={{ maxWidth: 680, width: '100%' }} />
      </div>

    </div>
  );
}
